export default "__VITE_ASSET__CRiPL7$6__"